import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';

// Constant
import { ROLES } from 'services/constants';

// Actions
import { uiTriggerDrawer } from 'store/ui-reducer';
import { rejectUnpApById, addUnpAp, replaceAp } from '../../reducer/actions';

// Components
import UnplannedCard from './UnplannedCard';
import RejectModal from './modals/RejectedModal';
import ApplyModal from './modals/ApplyModal/ApplyModal';
import UnplannedSnack from './UnplannedSnack';

// Styles && Images
import CloseIcon from 'assets/images/close-24.svg';
import styles from './styles';

class Drawer extends Component {
  constructor() {
    super();
    this.state = {
      isOpenModalType: null,
      currentAppointmentData: null,
      isResolved: false,
      isShowSnackToast: false
    };
    this.onCloseModal = this.onCloseModal.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { unplannedList } = this.props;
    const { currentAppointmentData, isOpenModalType, isShowSnackToast } = this.state;
    const currentId = currentAppointmentData && currentAppointmentData.id;
    const isExist = Array.isArray(unplannedList) && unplannedList.some(ap => ap.id === currentId);
    const isPrevExist =
      Array.isArray(prevProps.unplannedList) &&
      prevProps.unplannedList.some(ap => ap.id === currentId);
    // if someone resolve this appointment but we still have open modal
    if (currentId && isPrevExist && !isExist && isOpenModalType) {
      this.setState({ isResolved: true });
    }

    if (Array.isArray(unplannedList)) {
      if (unplannedList.length && !isShowSnackToast) {
        this.setState({ isShowSnackToast: true });
      } else if (!unplannedList.length && isShowSnackToast) {
        this.setState({ isShowSnackToast: false });
      }
    }
  }

  closeDrawer() {
    const { uiTriggerDrawer } = this.props;
    uiTriggerDrawer();
    this.onCloseModal();
  }

  onChooseInCard(isOpenModalType, currentAppointmentData) {
    this.setState({
      isOpenModalType,
      currentAppointmentData
    });
  }

  onCloseModal() {
    this.setState({
      isOpenModalType: null,
      currentAppointmentData: null,
      isResolved: false
    });
  }

  onReject(rejMessage) {
    const { currentAppointmentData } = this.state;
    const { rejectUnpApById } = this.props;
    rejectUnpApById(currentAppointmentData.id, rejMessage).then(() => {
      this.onCloseModal();
    });
  }

  render() {
    const { currentAppointmentData, isOpenModalType, isResolved, isShowSnackToast } = this.state;
    const {
      isOpenDrawer,
      unplannedList,
      practitionersList,
      i18n,
      addUnpAp,
      replaceAp,
      role
    } = this.props;
    const isOpen = role === ROLES.RADIOLOGY ? false : isOpenDrawer;

    return (
      <styles.DrawWrapper isOpen={isOpen}>
        <styles.FixedDrawContent>
          <styles.CaptionSection>
            <span>{i18n.t('events_tab')}</span>
            <img src={CloseIcon} alt="close-icon" onClick={this.closeDrawer.bind(this)} />
          </styles.CaptionSection>

          <styles.SectionContent>
            {Array.isArray(unplannedList) && unplannedList.length
              ? unplannedList.map(el => (
                <UnplannedCard
                  key={el.id}
                  data={el}
                  practitionersList={practitionersList}
                  onChoose={this.onChooseInCard.bind(this)}
                />
              ))
              : null}
          </styles.SectionContent>
        </styles.FixedDrawContent>

        {/* ──── Modals ────────────────────────────────────────────────────────────────────── */}
        <RejectModal
          isOpen={isOpenModalType === 'reject'}
          closeModal={this.onCloseModal}
          onReject={this.onReject.bind(this)}
          isResolved={isResolved}
        />

        <ApplyModal
          addUnpAp={addUnpAp}
          unplannedAppointmentData={currentAppointmentData}
          isOpen={isOpenModalType === 'add'}
          closeModal={this.onCloseModal}
          isResolved={isResolved}
          replaceAp={replaceAp}
        />

        {/* ──── SnackBar ───────────────────────────────────────────────────────────────────── */}
        {role !== ROLES.RADIOLOGY ? <UnplannedSnack isShow={isShowSnackToast} /> : null}
      </styles.DrawWrapper>
    );
  }
}
const mapStateToProps = state => {
  const { practitioner } = state;
  return {
    role: state.auth.role,
    isOpenDrawer: state.ui.isOpenDrawer,
    unplannedList: practitioner.appointments.unplannedList,
    practitionersList: practitioner.common.practitionersList
  };
};

export default translate()(
  connect(
    mapStateToProps,
    { addUnpAp, uiTriggerDrawer, rejectUnpApById, replaceAp }
  )(Drawer)
);
